module.exports = __webpack_public_path__ + "static/media/failureAlert.e606c479.svg";